import React from "react";
import styles from "../WalletConnector.module.css";
export default function Synchronizing() {
  return (
    <div className={styles.centeredSection}>
      <div className={styles.syncText}>Synchronizing...</div>
      <div className={styles.spinner}></div>
    </div>
  );
}
